<div
	class="chart-wrapper"
	[class.chart-wrapper--pie]="isPieChart"
	*ngIf="config"
>
	<canvas
		baseChart
		[type]="$any(chartType)"
		[data]="chartData"
		[options]="chartOptions"
		[plugins]="plugins"
	></canvas>
</div>
